import { Divider } from "@chakra-ui/layout";

export function AuthDivider() {
  return <Divider mt={2} />;
}
